import ApiClient from '../ApiClient';

class AssistantCopilotThreads extends ApiClient {
  constructor() {
    super('assistant/copilot_threads', { accountScoped: true });
  }
}

export default new AssistantCopilotThreads();
